import { NgModule } from '@angular/core';
import { WellLogsService } from './well-logs.service';
import { WellLogsBackend } from './well-logs.backend';

@NgModule({
  providers: [WellLogsService, WellLogsBackend],
})
export class WellLogsModule {}
